import { render, staticRenderFns } from "./StaffProfile.vue?vue&type=template&id=68525536&scoped=true&"
import script from "./StaffProfile.vue?vue&type=script&lang=js&"
export * from "./StaffProfile.vue?vue&type=script&lang=js&"
import style0 from "./StaffProfile.vue?vue&type=style&index=0&id=68525536&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68525536",
  null
  
)

export default component.exports